export const KEY_API_LOADED_TIMESTAMP = 'keyApiLoadedTimestamp';
